import React from "react";

import ReCAPTCHA from "react-google-recaptcha";

const Recaptacha = () => {


  
  return (
    <>
      <ReCAPTCHA  sitekey="6LeLZE8pAAAAACpkMvtoVtmUPo595-ty1qeuoUn3"/>
    </>
  );
};

export default Recaptacha;
